<template>
  <div class="inspection-report-list">
    <div v-if="statements" class="panel panel-default border-panel card-view">
      <div class="panel-wrapper collapse in">
        <div class="panel-body">
          <table>
            <thead>
              <tr>
                <td style="border: none !important">
                  <!--place holder for the fixed-position header-->
                  <div class="page-header-space"></div>
                </td>
              </tr>
            </thead>
            <tbody>
              <div class="table-wrap">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                      <tr style="width: 100%">
                        <th style="width: 20%">
                          <span>{{$t(`app.inspection_statement.headers.identifier`)}}</span>
                        </th>
                        <th style="width: 30%">
                          <span>{{$t(`app.inspection_statement.headers.inspection_item`)}}</span>
                        </th>
                        <th style="width: 30%">
                          <span>{{$t(`app.inspection_statement.headers.detections`)}}</span>
                        </th>
                        <th style="width: 20%">
                          <span>{{$t(`app.inspection_statement.headers.assets`)}}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        style="width: 100%"
                        :class="row.result === 'mismatched' ? 'table-row table-row-mismatched' : 'table-row'"
                        v-for="(row, index) in statements"
                        :key="index"
                      >
                        <td class="base-td" style="width: 20%">
                          <span
                            class="action-button"
                          >{{row.provided_identifier}}</span>
                        </td>
                        <td class="base-td" style="width: 30%">
                          <span class="title">{{$t(`app.statements.locations`)}}</span>
                          <span>{{locationList(row.statement.locations) || $t('app.noValue')}}</span>
                          <span
                            class="title with-margin"
                          >{{$t(`app.statements.verification_question_name`)}}</span>
                          <span>{{row.statement.verification_question_name || $t('app.noValue')}}</span>
                          <span class="title with-margin">{{$t(`app.statements.statement`)}}</span>
                          <span class="statement title">{{row.statement.statement || $t('app.noValue')}}</span>
                        </td>
                        <td class="base-td" style="width: 30%">
                          <span class="title">{{$t(`app.statements.status`)}}</span>
                          <span v-if="editable" class="icon">
                            <a class="pull-left inline-block mr-15 action-button">
                              <i @click="updateResult(row)" class="zmdi zmdi-edit"></i>
                            </a>
                          </span>
                          <span
                            :class="row.result"
                          >{{$t(`app.inspection_statement.results_in_sentece.${row.result}`)}}</span>
                          <span
                            v-if="row.inspection_note"
                            class="title with-margin"
                          >{{$t(`app.inspection_statement.memo`)}}</span>
                          <span v-if="row.inspection_note" class="memo">
                            {{row.inspection_note.text}}
                            <span v-if="editable" class="icon">
                              <a class="pull-left inline-block mr-15 action-button">
                                <i
                                  @click="updateMemoClicked(row,row.inspection_note)"
                                  class="zmdi zmdi-edit"
                                ></i>
                              </a>
                            </span>
                          </span>
                          <span v-else class="memo">
                            {{$t(`app.inspection_memo.empty_memo`)}}
                            <span v-if="editable" class="icon">
                              <a class="pull-left inline-block mr-15 action-button">
                                <i
                                  @click="updateMemoClicked(row,row.inspection_note)"
                                  class="zmdi zmdi-edit"
                                ></i>
                              </a>
                            </span>
                          </span>
                          <span
                            v-if="row.tasks.length > 0"
                            class="title with-margin"
                          >{{$t(`app.inspection_statement.tasks`)}}</span>
                          <ul>
                            <li v-for="(task, index) in row.tasks" :key="index">
                              <span class="title task-name" @click="navigateToTask(task)">
                                {{task.provided_identifier}}
                                <span
                                  class="task-type"
                                >{{$t(`app.tasks.types.${task.task_type}`)}}</span>
                              </span>
                              <span v-if="editable" class="icon">
                                <a class="pull-left inline-block mr-15 action-button">
                                  <i @click="updateTask(task)" class="zmdi zmdi-edit"></i>
                                </a>
                              </span>
                              <span v-if="task.name">
                                <span class="subTitle">{{$t(`app.inspection_statement.name`)}}</span>
                                {{task.name}}
                              </span>
                              <span v-if="task.assignee_user">
                                <span class="subTitle">{{$t(`app.inspection_statement.assignee_user`)}}</span>
                                {{task.assignee_user.name}}
                              </span>
                              <span>
                                <span class="subTitle">{{$t(`app.inspection_statement.deadline`)}}</span>
                                {{task.deadline| moment("YYYY-MM-DD")}}
                              </span>
                              <span class="mb-10">
                                <span class="subTitle">{{$t(`app.inspection_statement.description`)}}</span>
                                {{task.description}}
                              </span>
                            </li>
                          </ul>
                        </td>
                        <td style="width: 20%">
                        <statement-asset
                            v-for="(asset, index) in row.inspection_memos.map(x => x.asset).concat()"
                            :key="index"
                            :asset="asset"
                            :inspectionStatementId="row.id"
                            :statementId="row.statement.id"
                            :readOnly="readOnly"
                            @removeAssetClicked="removeAssetClicked"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </tbody>
          </table>

        </div>
      </div>
    </div>
    <div v-if="!statements || statements.length === 0" class="empty-section">{{$t('app.errors.no_result')}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StatementAsset from '@/components/modules/inspections/StatementAsset';

export default {
  name: 'InspectionReportList',
  components: {
    'statement-asset': StatementAsset,
  },
  props: {
    statements: {
      type: Array,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      storedInspectionStatement: {},
      editable: true,
    };
  },
  created() {
    this.editable = this.$route.name !== 'InspectionReportScreen' && !this.readOnly;
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
    }),
  },
  mounted() {},
  methods: {
    updateResult(row) {
      this.$emit('updateResult', row);
    },
    updateTask(row) {
      this.$emit('updateTask', row);
    },
    updateMemoClicked(row, memo) {
      if (memo !== null) {
        this.$emit('updateMemoClicked', {
          memo,
          inspectionStatementId: row.id,
        });
      } else {
        this.$emit('updateMemoClicked', {
          memo: { text: ' ' },
          inspectionStatementId: row.id,
        });
      }
    },
    removeAssetClicked(payload) {
      this.statements.forEach((x) => {
        if (x.id === payload.inspectionStatementId) {
          let deletAbleIndex;
          x.inspection_memos.forEach((memo, index) => {
            if (memo.asset && memo.asset.id === payload.id) {
              deletAbleIndex = index;
            }
          });
          x.inspection_memos.splice(deletAbleIndex, 1);
        }
      });
    },
    navigateToTask(task) {
      if (!this.editable) {
        if (this.loggedInUser.role !== 'worker') {
          this.$router.push({ name: 'TasksScreen', params: { id: task.id } });
        }
      } else {
        this.$emit('updateTask', task);
      }
    },
    locationList(data) {
      const mappedNames = data.map(item => item.name);
      return mappedNames.join(', ');
    },
  },
};
</script>

<style lang="scss">
.inspection-report-list {
  .action-button {
    cursor: pointer;
  }

  .base-link {
    font-weight: 500;
  }

  .table-row:hover {
    background-color: rgba(163, 163, 163, 0.05) !important;
  }

  .table-row-mismatched {
    background-color: rgba(218, 69, 69, 0.082);
  }

  table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    span {
      display: block;
      word-break: normal;
    }

    i.active {
      color: var(--main-color);
    }

    i.inactive {
      color: #bcbccb;
    }

    [class*="ti-"] {
      font-size: 20px !important;
    }
  }
  .array-span {
    background: var(--main-color);
    border-radius: 4px;
    color: #ffffff;
    font-size: 11px;
    padding: 3px 4px 3px 4px;
    margin-right: 10px;
    float: left;
    text-align: center;
  }

  .empty-section {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-top: 40px;
  }

  .statement {
    // margin-bottom: 30px;
  }

  .memo {
    font-weight: bold;
  }

  .matched {
    color: green;
  }

  .mismatched {
    color: red;
  }

  .unknown {
    color: var(--main-color);
  }

  .icon {
    float: right !important;
    clear: none !important;
  }

  .title {
    font-weight: bold;
  }

  .subTitle {
    float: left;
    font-weight: bold;
    margin-right: 5px;
  }

  .with-margin {
    margin-top: 10px;
  }

  ul {
    list-style: disc;
  }

  .base-td {
    vertical-align: baseline;
  }

  .task-type {
    background: #ff6565;
    border-radius: 14px;
    color: #ffffff;
    font-size: 11px;
    padding: 4px 8px 4px 8px;
    margin-left: 5px;
  }

  .task-name {
    display: -webkit-inline-box;
    cursor: pointer;
  }

  @media print {
    .panel-body {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
    .panel-default {
      padding-top: 0;
    }
    .icon {
      display: none;
    }
    .table-responsive {
      overflow: hidden;
    }
    table {
      table-layout: fixed;
      border-collapse: collapse;
      width: 100%;
      td,
      th {
        font-size: 12px !important;
        border: 1px solid #eee !important;
      }

      td {
        padding-bottom: 0px !important;
      }
      span {
        display: block;
        word-wrap: break-word;
        white-space: normal;
      }
      #statement-asset {
        .asset-url {
          display: block;
        word-wrap: break-word;
        white-space: normal;
        }
      }
    }
  }
}
.page-header-space {
  @media print {
    height: 20px;
  }

  height: 0px;
}
#inspection-header {
  @media print {
    // page-break-after: always;
  }
  h3,
  h6 {
    @media print {
      // display: inline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/lists/InspectionReportList.vue